import { Button } from "@xola/ui-kit";
import clsx from "clsx";
import React, { ButtonHTMLAttributes, ReactNode } from "react";

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ReactNode;
    size?: string;
    disabled?: boolean;
    onClick?: (...arguments_: any[]) => any;
    isLoading?: boolean;
    children: ReactNode;
}

export const SecondaryButton = ({
    type = "button",
    size = "medium",
    disabled = false,
    onClick,
    children,
    ...rest
}: SecondaryButtonProps) => (
    <Button
        className={clsx(disabled ? "pointer-events-none" : "pointer-events-auto")}
        type={type}
        disabled={disabled}
        variant="outline"
        color="secondary"
        size={size}
        onClick={onClick}
        {...rest}
    >
        {children}
    </Button>
);
